import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/patient/out/homepage',
    component: () => import('@/pages/patient/out/homepage'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '就诊人管理');
    }
  }
];
